import { render, staticRenderFns } from "./LoyaltyCardItem.vue?vue&type=template&id=2e4e796c&scoped=true&"
import script from "./LoyaltyCardItem.vue?vue&type=script&lang=js&"
export * from "./LoyaltyCardItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e4e796c",
  null
  
)

export default component.exports